// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caller-card-wrap .left-img-wrap {
    position: relative;
    /* height: 100%; */
}

.caller-card-wrap .left-img-wrap img {
    width: 100%;
}

.caller-card-wrap .left-img-wrap .bottom-icon-wrap {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.81);
    height: 88px;
    width: 100%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 27px;
}

.caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title {
    font-weight: 700;
    line-height: 75px;
    font-size: 22px;
    color: #000000;
}

.caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title span {
    font-weight: 500;
}

.caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap {
    display: flex;
}

.caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button {
    background-color: transparent;
    border: none;
}

.caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icn-2 {
    padding-left: 20px;
}

.top-title-mob {
    display: none;
}

@media (max-width: 1650px) {
    .caller-card-wrap .left-img-wrap .bottom-icon-wrap {
        padding: 0px 20px;

    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title {
        font-size: 16px;
    }
}

@media (max-width: 768px) {
    .left-img-wrap .top-title-mob {
        display: block;
        background-color: #ffffff;
        color: #38bbf4;
        font-size: 12px;
        font-weight: 600;
        line-height: 15px;
        border-radius: 10px;
        padding: 6px 10px;
        position: absolute;
        left: 2%;
        top: 5%;
        width: 80%;
        display: flex;
        gap: 7px;
        align-items: center;
    }

    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon {
        top: 4%;
    }

    .left-img-wrap .top-title-mob span {
        display: none;
    }

    .left-img-wrap .top-img-mic-icon img {
        width: 40px;
        height: 40px;
    }

    .left-img-wrap .warning {
        color: #ffb800;
    }

    .left-img-wrap .error {
        color: #ef3f3f;
    }

    .left-img-wrap .top-title-mob img {
        width: 16px;
        height: 16px;
    }

    .caller-card-wrap .left-img-wrap .caller-img {
        border-radius: 10px;
        width: 100%;
        height: 100%;
    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap {
        height: 42px;
        border-radius: 0px 0px 10px 10px;
        padding: 6px 12px;
    }


    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title {
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;
    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title span {
        font-weight: 500;
    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap img {
        height: 30px;
        width: 30px;
    }

    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icn-2 {
        padding-left: 0px;
        margin-left: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/CallerCard/CallerCard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,YAAY;IACZ,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,iBAAiB;;IAErB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,QAAQ;QACR,OAAO;QACP,UAAU;QACV,aAAa;QACb,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gCAAgC;QAChC,iBAAiB;IACrB;;;IAGA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ","sourcesContent":[".caller-card-wrap .left-img-wrap {\n    position: relative;\n    /* height: 100%; */\n}\n\n.caller-card-wrap .left-img-wrap img {\n    width: 100%;\n}\n\n.caller-card-wrap .left-img-wrap .bottom-icon-wrap {\n    position: absolute;\n    background-color: rgba(255, 255, 255, 0.81);\n    height: 88px;\n    width: 100%;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 27px;\n}\n\n.caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title {\n    font-weight: 700;\n    line-height: 75px;\n    font-size: 22px;\n    color: #000000;\n}\n\n.caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title span {\n    font-weight: 500;\n}\n\n.caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap {\n    display: flex;\n}\n\n.caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icon-button {\n    background-color: transparent;\n    border: none;\n}\n\n.caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icn-2 {\n    padding-left: 20px;\n}\n\n.top-title-mob {\n    display: none;\n}\n\n@media (max-width: 1650px) {\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap {\n        padding: 0px 20px;\n\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title {\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 768px) {\n    .left-img-wrap .top-title-mob {\n        display: block;\n        background-color: #ffffff;\n        color: #38bbf4;\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 15px;\n        border-radius: 10px;\n        padding: 6px 10px;\n        position: absolute;\n        left: 2%;\n        top: 5%;\n        width: 80%;\n        display: flex;\n        gap: 7px;\n        align-items: center;\n    }\n\n    .interview-mode-bottom-content .left-img-wrap .top-img-mic-icon {\n        top: 4%;\n    }\n\n    .left-img-wrap .top-title-mob span {\n        display: none;\n    }\n\n    .left-img-wrap .top-img-mic-icon img {\n        width: 40px;\n        height: 40px;\n    }\n\n    .left-img-wrap .warning {\n        color: #ffb800;\n    }\n\n    .left-img-wrap .error {\n        color: #ef3f3f;\n    }\n\n    .left-img-wrap .top-title-mob img {\n        width: 16px;\n        height: 16px;\n    }\n\n    .caller-card-wrap .left-img-wrap .caller-img {\n        border-radius: 10px;\n        width: 100%;\n        height: 100%;\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap {\n        height: 42px;\n        border-radius: 0px 0px 10px 10px;\n        padding: 6px 12px;\n    }\n\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title {\n        font-size: 12px;\n        line-height: 20px;\n        font-weight: 700;\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .bottom-title span {\n        font-weight: 500;\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap img {\n        height: 30px;\n        width: 30px;\n    }\n\n    .caller-card-wrap .left-img-wrap .bottom-icon-wrap .feature-icon-wrap .icn-2 {\n        padding-left: 0px;\n        margin-left: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
